import { TypeChecker } from '@attain-apps/type-guards'

/**
 * ID of an individual entity
 *
 * __NOTE:__ we currently only support strings as we encountered issues when
 * trying to also support numbers
 */
export type EntityId = string
export namespace EntityId {
  export const isEntityId: TypeChecker<EntityId> = TypeChecker.isString
}
